module.exports = __webpack_public_path__ + "img/content5.e44c5789.png";